// Angular imports
import { Injectable } from '@angular/core';

// Constants import
import { HelpConstants } from '../../_constants/help-key-constants';

// Service imports
import { EnvironmentConfigService } from '../environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class CiraHelpService {
  constructor(private envConfig: EnvironmentConfigService) {}

  getHelpLink(helpId: string, helpKey: string, communityId: number): string {
    let helpLink: string = this.envConfig.mainCiraHelpUrl;
    let contextStr = '';
    let helpIdStr = '';
    let helpKeyStr = '';

    if (!!communityId) {
      contextStr = '/ct/c' + communityId.toString();
    }
    if (!!helpId) {
      helpIdStr = '/' + helpId;
    } else if (!!helpKey) {
      helpKeyStr = '&key=' + helpKey;
    }

    helpLink = helpLink.replace('{CONTEXT}', contextStr);
    helpLink = helpLink.replace('{HELP_ID}', helpIdStr);
    helpLink += helpKeyStr;

    return helpLink;
  }

  showHelp(helpURL: string): void {
    window.open(helpURL);
  }

  getAddPropertyHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAddPropertyKey,
      communityId
    );
  }

  getContactUsHelpLink(communityId: number): string {
    return this.getHelpLink(null, HelpConstants.helpContactUsKey, communityId);
  }

  getReportViolationHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpReportViolationKey,
      communityId
    );
  }

  getBoardOfDirectorHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpBoardOfDirectorKey,
      communityId
    );
  }

  getRestrictionSummaryHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpRestrictionSummaryKey,
      communityId
    );
  }

  getSideNavHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.defaultResidentPortalKey,
      communityId
    );
  }

  getAccountsPaymentHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAccountsPaymentKey,
      communityId
    );
  }

  getAccountsStatementHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAccountStatementKey,
      communityId
    );
  }

  getAccessMediaListHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAccessMediaListKey,
      communityId
    );
  }

  getRecurringPaymentHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpRecurringPaymentKey,
      communityId
    );
  }

  getMyDocumentsHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpMyDocumentsKey,
      communityId
    );
  }

  getCommunityDashboardLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpCommunityDashboardKey,
      communityId
    );
  }

  getCommunityInformationLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpCommunityInformationKey,
      communityId
    );
  }

  getCommunityLegalInformationLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpCommunityLegalInformationKey,
      communityId
    );
  }

  getCommunityCalendarLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpCommunityCalendarKey,
      communityId
    );
  }

  getAdditionalInfoKeyLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAdditionalInfoKey,
      communityId
    );
  }

  getAccountInfoLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpPropertyInformationKey,
      communityId
    );
  }

  getPropertyInfoLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpPropertyInformationKey,
      communityId
    );
  }

  getOwnerInfoLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpOwnerInformationKey,
      communityId
    );
  }

  getContactInfoLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpContactInformationKey,
      communityId
    );
  }

  getDirectorySharingLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpDirectorySharingKey,
      communityId
    );
  }

  getArchitechturalApplicationLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpArchitechturalApplicationKey,
      communityId
    );
  }

  getMyDashboardHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpMyDashboardKey,
      communityId
    );
  }

  getComplianceHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpAccountComplianceKey,
      communityId
    );
  }

  getResidentDirectoryHelpLink(communityId: number): string {
    return this.getHelpLink(
      null,
      HelpConstants.helpResidentDirectoryKey,
      communityId
    );
  }

  getWorkOrdersHelpLink(communityId: number): string {
    return this.getHelpLink(null, HelpConstants.helpWorkOrdersKey, communityId);
  }
}
